import { Grid, Typography } from "@mui/material";
import React from "react";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Image, { StaticImageData } from "next/image";
import Link from "next/link";

type SliderItem = {
  name: string;
  icon: StaticImageData | string;
  redirectLink: string;
};

function AppSlider({
  list,
  title,
  directionLTR,
  width,
  numbers,
  titleMargin,
  sliderPad,
  pointer,
  marquee,
}: {
  list: SliderItem[];
  title?: string;
  directionLTR?: boolean;
  width?: number;
  numbers?: number;
  titleMargin?: string;
  sliderPad?: string;
  pointer?: boolean;
  marquee?: boolean;
}) {
  const settings: Settings = {
    infinite: Boolean(marquee),
    speed: marquee ? 4000 : 1500,
    slidesToShow: numbers ? numbers : 5,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: marquee ? 0 : 2000,
    centerMode: false,
    arrows: false,
    easing: marquee ? "linear" : "ease",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <Grid
      sx={{
        padding: sliderPad ? sliderPad : "0",
      }}
      className="container"
    >
      {title ? (
        <Grid
          style={{
            position: "relative",
            display: "flex",
            justifyContent: "center",
            padding: "8px 0",
            margin: titleMargin ? titleMargin : "auto",
          }}
        >
          <Typography
            sx={{
              background: "white",
              padding: "0 8px",
              zIndex: 1,
              fontWeight: "bold",
              fontSize: { xs: "24px", md: "32px" },
            }}
          >
            {title}
          </Typography>
          <Grid
            style={{
              position: "absolute",
              height: 1,
              width: "100%",
              background: "lightgray",
              top: "calc(50% + 0.5px)",
              zIndex: 0,
            }}
          ></Grid>
        </Grid>
      ) : null}

      <Grid
        style={{
          padding: "8px 0",
          transform: directionLTR ? "rotate(180deg)" : "rotate(0deg)",
        }}
      >
        <Slider {...settings}>
          {list.map((m, i) => {
            const frameWidth = width ? width : 140;
            const frameHeight = 140;
            const img = (
              <Image
                width={frameWidth}
                height={frameHeight}
                src={m.icon}
                alt={m.name}
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  outline: "none",
                  transform: directionLTR ? "rotate(180deg)" : "rotate(0deg)",
                  objectFit: "contain",
                  cursor: pointer ? "pointer" : "normal",
                }}
                className="app-slider-img"
                loading="lazy"
              />
            );

            return (
              <div key={i}>
                <div
                  style={{
                    width: frameWidth,
                    height: frameHeight,
                    margin: "0 auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "10px",
                    boxSizing: "border-box",
                  }}
                >
                  {m?.redirectLink?.length > 0 ? (
                    <Link href={m.redirectLink} rel="preload">
                      {img}
                    </Link>
                  ) : (
                    img
                  )}
                </div>
              </div>
            );
          })}
        </Slider>
      </Grid>
    </Grid>
  );
}

export default AppSlider;
